import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as files from '@debbie/cortex/dist/api/files.js';
import React, { useEffect, useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import Loading from './Loading.js';
const FileDropzone = (props) => {
    const lang = useSelector((s) => s.lang);
    const [uploadQueue, setUploadQueue] = useState([]);
    const [hovering, setHovering] = useState(false);
    const isUploadingRef = useRef(false);
    const onDrop = async (acceptedFiles) => {
        if (props.onDrop) {
            props.onDrop();
        }
        setUploadQueue((prev) => [...prev, ...acceptedFiles]);
    };
    const uploadMutation = useMutation(async (uploadFile) => {
        const content = await promiseFileReader(uploadFile);
        if (!uploadFile.type) {
            console.error('uploadFile.type (contentType) is missing', uploadFile);
        }
        const { file } = await files.save({
            content: content.split('base64,')[1],
            name: uploadFile.name,
            contentType: uploadFile.type || 'text/plain',
        }, {
            parseInvoice: props.parseInvoice,
        });
        // @ts-ignore
        props.onChange && (await props.onChange(file, uploadFile));
    }, {
        onSuccess: () => {
            isUploadingRef.current = false;
            setUploadQueue((previous) => previous.slice(1));
        },
        onError: (error) => {
            isUploadingRef.current = false;
            setUploadQueue([]);
            errorNotification(lang, error, 'create', lang.errorEntities.file);
        },
    });
    const loading = uploadMutation.isLoading || uploadQueue.length > 0;
    useEffect(() => {
        if (uploadQueue.length === 0 || isUploadingRef.current) {
            return;
        }
        isUploadingRef.current = true;
        uploadMutation.mutate(uploadQueue[0]);
    }, [uploadQueue]);
    useEffect(() => {
        props.setLoading?.(loading);
        return () => props.setLoading?.(false);
    }, [loading]);
    const promiseFileReader = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                resolve(event.target.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    return (React.createElement("div", { onDrop: (event) => {
            event.preventDefault();
            const data = event.dataTransfer.getData('file-dnd');
            if (data) {
                props.onChange && props.onChange(JSON.parse(data));
            }
        } }, React.createElement(Dropzone, { acceptStyle: {
            background: 'lightgreen',
            display: 'hidden',
        }, onDragOver: () => setHovering(true), onDragLeave: () => setHovering(false), onDropAccepted: () => setHovering(false), onDropRejected: () => setHovering(false), rejectStyle: {
            background: 'red',
        }, onDrop: onDrop, ref: props.dropzoneRef, style: props.style, accept: props.accept, disableClick: true },
        props.children,
        (hovering || loading) && (React.createElement(Hovering, null,
            React.createElement(HoverText, null, loading ? React.createElement(Loading, { width: "40px" }) : lang.inputs.dropToUpload))))));
};
export default FileDropzone;
const HoverText = styled.h2 `
  font-size: 20px;

  &::before {
    content: ' ';
    position: absolute;
    left: 50%;
    top: 50%;
    box-shadow: 0px 0px 58px 30px ${THEME.COLOR_ACCENT};

    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: pulsing;
    animation-timing-function: ease-in-out;
  }

  @keyframes pulsing {
    0% {
      box-shadow: 0px 0px 50px 30px ${THEME.COLOR_ACCENT};
    }
    50% {
      box-shadow: 0px 0px 58px 30px ${THEME.COLOR_ACCENT};
    }
    100% {
      box-shadow: 0px 0px 50px 30px ${THEME.COLOR_ACCENT};
    }
  }
`;
const Hovering = styled.div `
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: ${THEME.COLOR_SECONDARY};
  z-index: 1;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid ${THEME.COLOR_ACCENT};
  border-radius: 3px;
`;
//# sourceMappingURL=FileDropzone.js.map